import { Link } from "react-router-dom";
import "./Footer.css";
import { FaFacebook, FaLinkedinIn, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { IoDocumentTextOutline } from "react-icons/io5";
import { SiGnuprivacyguard } from "react-icons/si";
import { BsChatText } from "react-icons/bs";

const Footer = () => {
  return (
    <footer>
      <div className="footer_box">
        <div className="row g-4">
          <div className="col-xl-3 col-lg-4 col-sm-6">
            <div className="footer_col_one">
              <div className="footer_logo_wrap">
                <Link className="footer_logo_link">
                  <img
                    src={
                      new URL("../../assets/logo_header.webp", import.meta.url)
                    }
                    alt=""
                  />
                </Link>
              </div>
              {/* <h5>Real Assets, Real Returns, On Chain</h5> */}
              <p>
                Assetly brings real assets onchain, making premium investments
                like real estate, commodities, and art accessible to all.
              </p>
              <div className="social_links_wrap">
                <a href="" className="social_link_fb">
                  <FaFacebook />
                </a>
                <a href="" className="social_links">
                  <FaXTwitter />
                </a>
                <a href="" className="social_links">
                  <FaYoutube />
                </a>
                <a href="" className="social_links">
                  <FaLinkedinIn />
                </a>
              </div>
            </div>
          </div>
          <div className="col-xl-2 col-lg-4 col-sm-6 foot_col_pl">
            <h3 className="footer_link_title">Assetly Flow</h3>
            <ul className="footer_link_lists">
              <li>
                <Link to={"/dashboard"}>Dashboard</Link>
              </li>
              <li>
                <Link to={"/profile"}>Profile</Link>
              </li>
              <li>
                <Link>Wallet Details</Link>
              </li>
              <li>
                <Link>Staking</Link>
              </li>
              <li>
                <Link>Liquidity Pool</Link>
              </li>
              <li>
                <Link>Hot Stakes</Link>
              </li>
              <li>
                <Link>Rewards</Link>
              </li>
            </ul>
          </div>
          <div className="col-xl-2 col-lg-4 col-sm-6">
            <h3 className="footer_link_title">Assets on-chain</h3>
            <ul className="footer_link_lists">
              <li>
                <Link>Real Estate</Link>
              </li>
              <li>
                <Link>Treasuries & Bonds</Link>
              </li>
              <li>
                <Link>Private Credit</Link>
              </li>
              <li>
                <Link>Commodities</Link>
              </li>
            </ul>
          </div>
          <div className="col-xl-2 col-lg-4 col-sm-6 foot_col_pl">
            <h3 className="footer_link_title">Company</h3>
            <ul className="footer_link_lists">
              <li>
                <Link>Market Place</Link>
              </li>
              <li>
                <Link to={"/institution"}>For Institution</Link>
              </li>
              <li>
                <Link to={"/aboutUs"}>About Us</Link>
              </li>
              <li>
                <Link to={"/contact"}>Contact Us</Link>
              </li>
            </ul>
          </div>
          <div className="col-xl-2 col-lg-4 col-sm-6 foot_col_pl">
            <h3 className="footer_link_title">Resources</h3>
            <ul className="footer_link_lists">
              <li>
                <Link to={"/"}>Legal</Link>
              </li>
              <li>
                <Link to={"/"}>Exchange Rates</Link>
              </li>
              <li>
                <Link to={"/"}>Supported Countries</Link>
              </li>
              <li>
                <Link to={"/"}>Supported Currencies</Link>
              </li>
              <li>
                <Link to={"/"}>Referral Program</Link>
              </li>
              <li>
                <Link to={"/"}>Affiliates Program</Link>
              </li>
            </ul>
          </div>
          {/* <div className="col-xl-3 col-lg-4 col-sm-6">
            <h3 className="footer_link_title">Get Assetly Insights</h3>
            <input
              type="email"
              className="footer_em_input"
              placeholder="Enter you email"
            />
            <button className="footer_btn">Subscribe</button>
            <p className="footer_em_cnt">
              We respect your privacy. Unsubscribe at any time.
            </p>
          </div> */}
        </div>
        <div className="footer_cpy_wrap">
          <p className="ft_cpy_cnt">
            &copy; 2025 Assetly. All Rights Reserved.
          </p>
          <div className="ft_cpy_lnk_wrap">
            <Link className="ft_cpy_lnk">
              <IoDocumentTextOutline />
              Terms of Service
            </Link>
            <Link className="ft_cpy_lnk">
              <SiGnuprivacyguard />
              Privacy Policy
            </Link>
            <Link className="ft_cpy_lnk">
              <BsChatText />
              Contact Support
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
